"use client";

import React, { useState, useEffect } from "react";
import { useTranslations } from "next-intl";

// Ленивая загрузка ReactPlayer для избежания SSR проблем
let ReactPlayer: React.ComponentType<{
  url: string;
  muted?: boolean;
  volume?: number;
  pip?: boolean;
  playbackRate?: number;
  loop?: boolean;
  onReady?: () => void;
  onStart?: () => void;
  onPlay?: () => void;
  onPause?: () => void;
  onEnded?: () => void;
}> | null = null;

interface VideoPlayerWrapperProps {
  url: string;
  onReady?: () => void;
}

export const VideoPlayerWrapper: React.FC<VideoPlayerWrapperProps> = ({
  url,
  onReady,
}) => {
  const tUi = useTranslations("Ui");
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && !ReactPlayer) {
      import("react-player").then((module) => {
        ReactPlayer = module.default;
        setIsLoaded(true);
      });
    } else if (ReactPlayer) {
      setIsLoaded(true);
    }
  }, []);

  if (!isLoaded || !ReactPlayer) {
    return <div>{tUi("VideoPlayerWrapper.zagruzkaPleera")}</div>;
  }

  return (
    <ReactPlayer
      url={url}
      muted={true} // Обязательно для автоплея в Chrome 66+
      volume={0.8} // Начальная громкость
      pip={true} // Picture-in-Picture режим
      playbackRate={1} // Скорость воспроизведения
      loop={false} // Не зацикливать
      {...(onReady ? { onReady } : {})}
    />
  );
};
